var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStocktwitsLogoSquare = function SvgStocktwitsLogoSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 53"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52.499,
    height: 52.499,
    fill: "#008FFF",
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stocktwits-logo-square_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#008FFF",
    d: "M7.943 12.195h36.071v31.446H7.943z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.455 12.616h24.1c1.813 0 2.834 1.405 2.27 3.122l-6.077 18.494c-.427 1.302-1.904 2.368-3.28 2.368h-6.414l-11.27 6.941 2.28-6.94H10.37c-1.813 0-2.835-1.406-2.27-3.122l6.076-18.495c.428-1.302 1.904-2.368 3.28-2.368m13.39 2.494-1.688 2.222-2.901-.005c-3.576-.01-6.118 3.133-5.12 5.89.434 1.51 2.195 2.224 3.578 2.784l.02.008a19 19 0 0 1 .805.338c.64.278.398 1.228-.302 1.232-1.237.012-8.055.037-8.055.037l-3.06 4.031h4.192l-1.682 2.216h4.192l1.682-2.216h.256q.454.003.932.017c1.698.043 3.563.088 4.836-.744 2.123-1.221 2.765-3.348 2.258-5.163-.434-1.51-2.196-2.224-3.578-2.784l-.036-.014c-.285-.115-.553-.224-.788-.332-.641-.278-.399-1.227.301-1.232 1.237-.012 8.056-.037 8.056-.037l3.06-4.031-4.454.006 1.688-2.223z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stocktwits-logo-square_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.943 12.195h36.071v31.446H7.943z"
  })))));
};
export default SvgStocktwitsLogoSquare;